import React, { useCallback } from 'react';

import Link from '@atlaskit/link';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { fg } from '@confluence/feature-gating';

import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../../controller/Controller';

const TEMP_LEARN_MORE_DOCUMENTATION =
	'https://confluence-permissions-help.atlassian.net/wiki/external/OTM4YTAxYmE4ZTBlNGEwNDhkNWUzZTZlNGZhZGRkZGU';

const SAC_LEARN_MORE_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';

export const LearnMoreChunk = (chunks: React.ReactNode[]) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const LEARN_MORE_DOCUMENTATION = fg('confluence_frontend_unified_restrict_and_share_ga')
		? SAC_LEARN_MORE_DOCUMENTATION
		: TEMP_LEARN_MORE_DOCUMENTATION;

	const handleClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE,
				action: 'clicked',
				actionSubject: 'link',
				actionSubjectId: 'blockedAccessLearnMore',
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<Link target="_blank" href={LEARN_MORE_DOCUMENTATION} onClick={handleClick}>
			{chunks}
		</Link>
	);
};
